import type {ISession} from '../types/ISession';
import type {IInputItem} from '../types/IInputItem';
import type {IEvent} from '../types/IEvent';


export interface FormSessionData {
  defaultValues: Record<string, string | boolean>;
  disabledFields: Record<string, boolean>;
}

const getValueFromSession = (fieldName: string, session?: ISession | null) => {
  if (!session) {
    return undefined;
  }

  if (fieldName === 'guestName') {
    return session.guest_name;
  }
  if (fieldName === 'guestEmail') {
    return session.guest_email;
  }
  if (fieldName === 'guestPhone') {
    return session.guest_phone;
  }

  return session.additional_question_answers?.find(
    (qa) => qa.question === fieldName,
  )?.answer;
};

const getValueFromEventDetails = (
  fieldName: string,
  eventDetails?: IEvent | null,
) => {
  if (!eventDetails) {
    return undefined;
  }

  if (fieldName === 'guestName') {
    return eventDetails.primary_guest_name;
  }
  if (fieldName === 'guestEmail') {
    return eventDetails.primary_guest_email;
  }
  if (fieldName === 'guestPhone') {
    return eventDetails.primary_guest_phone;
  }

  return eventDetails.primary_guest_additional_question_answers?.find(
    (qa) => qa.question === fieldName,
  )?.answer;
};

export const getDefaultFormValues = (
  formInputs: IInputItem[],
  session?: ISession | null,
  eventDetails?: IEvent | null,
): FormSessionData => {
  const result = {
    defaultValues: {} as Record<string, string | boolean>,
    disabledFields: {} as Record<string, boolean>,
  };

  formInputs.forEach((field) => {
    const sessionFieldValue = getValueFromSession(field.name, session);
    const eventFieldValue = getValueFromEventDetails(field.name, eventDetails);

    // set default value
    if (field.type === 'checkbox' || field.type === 'consent') {
      result.defaultValues[field.name] = sessionFieldValue
        ? Boolean(sessionFieldValue)
        : eventFieldValue
        ? Boolean(eventFieldValue)
        : false;
    } else {
      result.defaultValues[field.name] = sessionFieldValue
        ? String(sessionFieldValue)
        : eventFieldValue
        ? String(eventFieldValue)
        : field.options?.[0] || '';
    }

    // set disabled state
    result.disabledFields[field.name] =
      Boolean(sessionFieldValue) || Boolean(eventFieldValue);
  });

  return result;
};
